import { motion } from "framer-motion";
import { BRAND_LOGOS } from "../lib/data";
import { useLang } from "../lib/i18n";

const EASE = [0.16, 1, 0.3, 1];

export default function Brands() {
  const { t } = useLang();
  return (
    <div className="mt-28" data-testid="brands-section">
      <motion.h2
        initial={{ opacity: 0, y: 28 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.8, ease: EASE }}
        className="font-display text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight"
      >
        {t.brandsPre} <em className="font-serif italic font-medium text-brasslight">{t.brandsAccent}</em>
      </motion.h2>

      <div className="mt-12 grid grid-cols-1 md:grid-cols-2 gap-6">
        {t.brandsItems.map((b, i) => (
          <motion.article
            key={b.key}
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-70px" }}
            transition={{ duration: 0.85, delay: i * 0.14, ease: EASE }}
            className="group rounded-[2rem] bg-cream text-ink p-8 sm:p-10 shadow-[0_24px_70px_rgba(0,0,0,0.25)] transition-shadow duration-300 hover:shadow-[0_36px_90px_rgba(0,0,0,0.4)]"
            data-testid={`brand-card-${b.key}`}
          >
            <div className="shine-hover inline-flex items-center justify-center rounded-2xl bg-white border border-ink/10 px-6 py-4 min-h-[5.5rem] min-w-[11rem]">
              <img src={BRAND_LOGOS[b.key]} alt={`${b.name} logo`} className="h-12 w-auto object-contain" />
            </div>
            <h3 className="mt-7 font-display text-2xl sm:text-3xl font-bold tracking-tight">{b.name}</h3>
            <motion.p
              initial={{ opacity: 0, y: 14 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.7, delay: 0.25 + i * 0.14, ease: EASE }}
              className="mt-4 text-sm sm:text-base leading-relaxed text-ink/70"
            >
              {b.desc}
            </motion.p>
            <span className="mt-7 inline-flex rounded-full bg-ink px-4 py-2 text-xs font-bold text-brasslight">
              {b.tag}
            </span>
          </motion.article>
        ))}
      </div>
    </div>
  );
}
